export class Agency {
    address;
    agencyLogo;
    agencyName;
    distance;
    id;
    profileUrl;
    propertiesForSale;
    reviews;
    seniority;
    isRecommended;
    constructor(agency, isRecommended) {
        this.address = {
            city: agency.address.city,
            coordinates: {
                lat: agency.address.coordinates.lat,
                lng: agency.address.coordinates.lng,
            },
            zipCode: agency.address.zipCode,
        };
        this.agencyLogo = agency.agencyLogo;
        this.agencyName = agency.name;
        this.id = agency.legacyBrandId;
        this.profileUrl = agency.profileUrl;
        this.propertiesForSale = agency.classifiedCount;
        this.reviews = agency.reviews;
        this.seniority = agency.partnershipStartDatetime;
        this.isRecommended = isRecommended;
        this.distance = agency.distance ? agency.distance * 1000 : undefined;
    }
}
